import { withInstall } from '@ll-plus/utils'

import Calendar from './src/calendar.vue'

export const LlCalendar = withInstall(Calendar)
export default LlCalendar
export * from './src/calendar'

declare module 'vue' {
  export interface GlobalComponents {
    LlCalendar: typeof Calendar
  }
}